// extracted by mini-css-extract-plugin
export default {"container":"style_container__H-GQF","card":"style_card__l191T","title":"style_title__5ds4U","description":"style_description__umnkU","boldDescription":"style_boldDescription__JddNl"};